<template>
  <div v-if="carStations.length">
    <h2>{{ t('additionalStations') }}</h2>

    <div class="mb-4 mt-4 rounded-md bg-white px-4 py-1">
      <div class="grid grid-cols-3 gap-4 border-b pb-3 pt-3">
        <h4 class="font-normal">{{ t('station') }}</h4>
        <h4 class="font-normal">{{ t('fromDate') }}</h4>
        <h4 class="font-normal">{{ t('untilDate') }}</h4>
      </div>
      <div
        v-for="(station, i) in carStations"
        :key="i"
        class="grid grid-cols-3 gap-4 border-b py-3 font-semibold last:border-b-0"
      >
        <div>{{ getLocalizedField(station.station.info) }}</div>
        <div>{{ formatDate(station.fromDate, getDateFormat(), '-') }}</div>
        <div>{{ formatDate(station.untilDate, getDateFormat(), '-') }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import { formatDate } from '@/hooks/use-formatted-date';
import type { CarStations } from '@/entities/cars/car.entity';
import { getDateFormat } from '@/hooks/use-date-format';
import { computed } from 'vue';
import { DateTime } from 'luxon';
import { useLocalizedFields } from '@/hooks/use-localized-fields';

const props = defineProps<{
  carStations: CarStations[];
}>();

const carStations = computed(() =>
  props.carStations
    .filter((s) => s.primary === false)
    .sort((a, b) => {
      if (!a.fromDate) return -1;
      if (!b.fromDate) return 1;
      return DateTime.fromISO(a.fromDate) > DateTime.fromISO(b.fromDate) ? 1 : -1;
    }),
);

const { t } = useI18n();
const { getLocalizedField } = useLocalizedFields();
</script>

<i18n lang="json">
{
  "en": {
    "additionalStations": "Additional stations",
    "fromDate": "From date",
    "untilDate": "Until date",
    "station": "Station"
  },
  "de": {
    "additionalStations": "An weiteren Stationen buchbar",
    "fromDate": "Ab Datum",
    "untilDate": "Bis Datum",
    "station": "Station"
  },
  "es": {
    "additionalStations": "Estaciones adicionales",
    "fromDate": "Desde la fecha",
    "untilDate": "Hasta la fecha",
    "station": "Estación"
  }
}
</i18n>
